import { useAtom } from 'jotai'
import { pendingAtom } from './updateAtom'
import { useEffect, useRef } from 'react'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import {
  AiArtWorkStatus,
  pollAIArtWorks,
  pollAIArtWorksVariables,
} from '~/graphqls/types'
import { POLL_AI_ARTWORKS } from '~/graphqls/gqls'
import toast, { Toaster } from 'react-hot-toast'
import Link from 'next/link'
import { MyIcon } from '~/components/ui/MyIcon'

export default function UpdateEngine() {
  const [pending, setPending] = useAtom(pendingAtom)
  const timerRef = useRef(0)
  const pollProductsAction = useImperativeQuery<
    pollAIArtWorks,
    pollAIArtWorksVariables
  >(POLL_AI_ARTWORKS)

  const updateData = async () => {
    let nextTick = 30 * 1000

    const pendingids = pending.map(item => item.productID)

    try {
      const res = await pollProductsAction({ ids: pendingids })
      const list = res.data.pictureGraph?.aiArtworksGeneratingInfo?.list || []

      let willRemove: number[] = []
      let succsss: number[] = []
      list?.forEach(item => {
        // do something
        const cur = pending.find(p => p.productID === item?.id)
        if (item?.status === AiArtWorkStatus.SUCCESS) {
          toast.success(
            t => (
              <div className="flex items-center">
                <div>创作完成，</div>
                <Link href={`/ai/${item?.id}`} className="text-primary">
                  查看详情
                </Link>
                <div className="ml-2">
                  <MyIcon
                    icon="close"
                    className="text-neutral-400 text-[16px] cursor-pointer"
                    onClick={() => toast.dismiss(t.id)}
                  />
                </div>
              </div>
            ),
            {
              id: cur?.toastID,
              duration: 2000,
              iconTheme: {
                primary: 'rgba(69, 178, 107, 1)',
                secondary: '#000000',
              },
            }
          )
          willRemove.push(item?.id)
        } else if (item?.status === AiArtWorkStatus.FAIL) {
          toast.error(
            t => (
              <div className="flex items-center">
                <div>创作失败</div>
                <div className="ml-2">
                  <MyIcon
                    icon="close"
                    className="text-neutral-400 text-[16px] cursor-pointer"
                    onClick={() => toast.dismiss(t.id)}
                  />
                </div>
              </div>
            ),
            {
              id: cur?.toastID,
              duration: 2000,
              iconTheme: {
                primary: 'rgba(239, 70, 111, 1)',
                secondary: '#000000',
              },
            }
          )
          willRemove.push(item?.id)
        }
      })

      if (willRemove.length) {
        setPending(prev => {
          return prev.filter(item => !willRemove.includes(item.productID))
        })
      }

      nextTick =
        (res.data.pictureGraph?.aiArtworksGeneratingInfo?.nextPollingTime ||
          0) * 1000
    } catch (err) {
      console.error(err)
    }

    // nextPollingTime 返回0则表示都已经生成，不需要轮询
    if (!nextTick) return

    timerRef.current = window.setTimeout(updateData, nextTick)
  }

  useEffect(() => {
    window.clearTimeout(timerRef.current)

    /** 没有生成中的直接返回 */
    if (!pending.length) return

    updateData()

    return () => {
      window.clearTimeout(timerRef.current)
    }
  }, [pending.length])

  // 离开页面前清除所有toast，否则会导致重新返回页面时，toast永远不消失
  useEffect(() => {
    return toast.dismiss
  }, [])

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#000000',
            color: 'rgba(252, 252, 253, 1)',
            boxShadow:
              '0px 1px 4px rgba(255, 255, 255, 0.08), 0px 0px 8px rgba(255, 255, 255, 0.08)',
          },
        }}
      />
    </>
  )
}
